module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-left"
  }, [_c('div', {
    staticClass: "box-body form"
  }, [_c('br'), _vm._v(" "), (_vm.info && _vm.show.delBtn) ? _c('div', {
    staticClass: "del-block"
  }, [_c('div', {
    staticClass: "btn btn-danger",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    }
  }, [_vm._v("刪除群組")])]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("群組ID")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n          " + _vm._s(_vm.info.id) + "\n        ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandName),
      expression: "brandName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.brandName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.brandName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), (_vm.info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("建立時間")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n          " + _vm._s(_vm.info.create_time) + "\n        ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("更新時間")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_vm._v("\n          " + _vm._s(_vm.info.edit_time) + "\n        ")])]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("綁定店家")]), _vm._v(" "), _c('div', {
    staticClass: "form-control form-info"
  }, [_c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.goToStoreTable()
      }
    }
  }, [_vm._v("\n            綁定其他店家\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.info.stores), function(store) {
    return _c('div', {
      staticClass: "label-stores inline-block m-y-10"
    }, [_c('span', {
      staticClass: "label label-primary c-pointer",
      on: {
        "click": function($event) {
          return _vm.goToEditStore(store.store_id)
        }
      }
    }, [_vm._v(_vm._s(store.store_name) + " (" + _vm._s(store.store_id) + ")")]), _vm._v(" "), _c('br')])
  })], 2)]), _vm._v(" "), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('router-link', {
    staticClass: "text-white",
    attrs: {
      "to": {
        path: '/groupTable/' + _vm.$route.params.brand_id
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n        取消\n      ")])]), _vm._v(" "), (!_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.addGroup()
      }
    }
  }, [_vm._v("\n      新增\n    ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.upGroup()
      }
    }
  }, [_vm._v("\n      修改\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("群組名稱\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c605791"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Brand/Temp/GroupFormTemp.vue
// module id = 2368
// module chunks = 1